import { render, staticRenderFns } from "./fxqytwo.vue?vue&type=template&id=b9fd18a2&scoped=true&"
import script from "./fxqytwo.vue?vue&type=script&lang=js&"
export * from "./fxqytwo.vue?vue&type=script&lang=js&"
import style0 from "./fxqytwo.vue?vue&type=style&index=0&id=b9fd18a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fd18a2",
  null
  
)

export default component.exports